import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Icon, Modal } from '@phishtool/ui';
import { StyledQuoteButton } from './styled';
import { ContactForm } from '@phishtool/products';
import { unauthenticatedUserService } from '~service';
import { useModal } from '@phishtool/modal';
const modalId = 'contact';
const Contact = ({ quote }) => {
    const { openModal } = useModal();
    const onClick = (e) => {
        e.preventDefault();
        openModal(modalId);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(StyledQuoteButton, { href: "#", onClick: onClick, children: [_jsx("span", { children: "Contact sales team" }), _jsx(Icon, { name: "headphones", size: { width: 29, height: 36 }, alignment: "vertical" })] }), _jsx(Modal, { id: modalId, heading: "Contact us", headingSize: "large", children: _jsx(ContactForm, { firstName: quote.contactDetails.firstName, lastName: quote.contactDetails.lastName, email: quote.contactDetails.email, useSendContactRequest: unauthenticatedUserService.useSendContactRequest }) })] }));
};
export default Contact;
